(function () {
'use strict';

angular
    .module('aricRoutes', [
        'aricControllers',
        'services.historyCtxt'
    ])
    .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {
        $stateProvider
             .state('aricControlOwnerList', {
                 url: '/Aric/ControlOwner',
                 data: {
                     permissions: { featureRole: 'ControlGrpBusinessUnit_GovernanceManagement', key: 'Assessment', permission: 'Edit' }
                 },
                 resolve: {
                     activeProcess: ['grcGovernanceProcessService', function (service) {
                         return service.getActiveARIC();
                     }]
                 },
                 views: {
                     '': {
                         templateUrl: require('./aric.tpl.html'),
                         controller: 'AricController',
                     },
                     'mainContent@aricControlOwnerList': {
                         templateUrl: require('./aricControlOwnersList.tpl.html'),
                         controller: 'AricControlOwnersListController',
                         resolve: {
                             controlOwners: ['commonAricService', function (service) {
                                 return service.getControlOwnersAndStatus();
                             }]
                         }
                     }
                 }
             })

            .state('aricControlOwnerList.byOwner', {
                url: '@{OwnerID:int}',
                views: {
                    'mainContent@aricControlOwnerList': {
                        templateUrl: require('./aricControlsByOwner.tpl.html'),
                        controller: 'AricControlsByOwnerController',
                        resolve: {
                            controlsByOwner: ['$stateParams', 'commonAricService', function ($stateParams, service) {
                                return service.getControlsByOwner($stateParams.OwnerID);
                            }]
                        }
                    }
                }
            })

            .state('aricControlOwnerList.noActiveProcess', {
                url: '/NoActiveProcess',
                views: {
                    'mainContent@aricControlOwnerList': {
                        templateUrl: require('./withNoActiveProcess.tpl.html'),
                        controller: 'AricWithNoActiveProcessController',
                    }
                }
            });

        historyCtxtServiceProvider.setCtxtState('aricControlOwnerList.byOwner',
            '/app/Main/aric/GOVHistoryCtxtDirective-aricControlOwner.tpl.html'
        );
    }
})();
